module.exports = __webpack_public_path__ + "static/media/ReitzTeaBowls.11288a61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Reitz/ReitzTeaBowls.jpg
// module id = 5762
// module chunks = 0